const listsupgroup = (state = [], action) => {
  switch (action.type) {
    case 'LISTSUPGROUP':
    return {
        type: "LISTSUPGROUP",
        listsupgroup: action.listsupgroup
      }
    default:
      return state
  }
}

export default listsupgroup